import * as React from 'react';
import { LinkButton, ArticleHeading3, ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './RatingBanner.css';
import { trackRatingClick } from '../Title/tracking';

interface IRatingBannerProps {
  href: string;
}

export const RatingBanner: React.FunctionComponent<IRatingBannerProps> = ({ href }) => (
  <div className={styles['container']}>
    <div className={styles['header']}>
      <ArticleHeading3 color="white_100">Ежемесячный рейтинг профессионалов</ArticleHeading3>
    </div>
    <div className={styles['text']}>
      <ArticleParagraph2 color="white_100">
        на основе количества показов объявлений покупателям и арендаторам недвижимости на Циан
      </ArticleParagraph2>
    </div>
    <div>
      <LinkButton
        theme="fill_white_primary"
        href={href}
        onClick={trackRatingClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        Посмотреть рейтинг
      </LinkButton>
    </div>
  </div>
);
